import { Button } from 'antd';
import i18next from 'i18next';
import React from 'react';
import { fmtCm, QualityInfo } from './quality';
import { canUpscale, predictUpscalePx } from './upscale';

interface IProps {
	q?: QualityInfo;
	widthCm: number;
	minDpi: number;
	loading: boolean;
	onClick: () => void;
	small?: boolean;
}

// L'amélioration sera facturée (1 crédit) : on annonce le résultat AVANT le
// clic (sortie du modèle ~fixe → dpi prédictibles) et on retire le bouton
// quand la résolution maximale est déjà atteinte — jamais de clic payé pour rien.
const UpscaleAction: React.FC<IProps> = ({ q, widthCm, minDpi, loading, onClick, small }) => {
	if (q && !canUpscale(q.pxW, q.pxH)) {
		const maxCm = q.maxCm !== null ? q.maxCm : Math.floor((q.pxW / minDpi) * 2.54 * 10) / 10;
		return (
			<p className="dtf-upscale-maxed">
				✨ {i18next.t('dtf.amelioration-max-info')}{' '}
				{i18next.t('dtf.amelioration-max-conseil', { min: minDpi, max: fmtCm(maxCm) })}
			</p>
		);
	}
	let predict: React.ReactNode = null;
	if (q) {
		const { w } = predictUpscalePx(q.pxW, q.pxH);
		const dpi = Math.round(w / (widthCm / 2.54));
		const low = dpi < minDpi;
		const maxCm = Math.floor((w / minDpi) * 2.54 * 10) / 10;
		predict = (
			<p className={`dtf-upscale-predict${low ? ' dtf-upscale-predict-low' : ''}`}>
				{low
					? i18next.t('dtf.amelioration-prevision-basse', { dpi, w: fmtCm(widthCm), min: minDpi, max: fmtCm(maxCm) })
					: i18next.t('dtf.amelioration-prevision', { dpi, w: fmtCm(widthCm) })}
			</p>
		);
	}
	return (
		<>
			<Button
				className="dtf-upscale-btn"
				size={small ? 'small' : undefined}
				loading={loading}
				onClick={onClick}
				block={!small}
			>
				✨ {i18next.t('dtf.ameliorer')}
			</Button>
			{predict}
		</>
	);
};

export default UpscaleAction;
